import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AppInfoService } from '../common';

// Şifre ayarlarını temsil eden interface
export interface PasswordSettings {
  minCharacter: number;
  passwordChangeInterval: number;
  upperLower: boolean;
  specialChar: boolean;
  digitRequired: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class PasswordSettingsService {

  constructor(private http: HttpClient, private appInfo: AppInfoService) { }

  // Mevcut şifre ayarlarını backend'den getirir
  getPasswordSettings(){
    return this.http.get<any>(this.appInfo.appUrl + `api/password/getpasswordsettings`, this.appInfo.httpOptions);
  }

  // Şifre ayarlarını backend'e günceller
  updatePasswordSettings(settings: PasswordSettings): Observable<any> {
    return this.http.post<any>(this.appInfo.appUrl + `api/password/updatepasswordsettings`, settings, this.appInfo.httpOptions);

  }
}
